import { AuthMainForm } from './components';

export const AuthFeature = () => {
  return <AuthMainForm></AuthMainForm>;
};
